import {React, useEffect, useState} from 'react';
import { Navigation } from './commons/navigation.tsx';
import ToolsContent from './commons/tools-content-architecture.tsx';
import { Notifications } from './commons/notifications.tsx';
import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  ContentLayout,
  Flashbar,
  Header,
  HelpPanel,
  Link,
  SideNavigation,
  SplitPanel,
} from '@cloudscape-design/components';
import arch_diagram from './static/architecture_diagram.jpg';

export default function () {
    const [toolsOpen, setToolsOpen] = useState(true);
    const [navOpen, setNavOpen] = useState(true);
  
    return (
        <AppLayout
          breadcrumbs={
            <BreadcrumbGroup
              items={[
                { text: 'Plantly', href: '#' },
                { text: 'Architecture', href: '#' },
              ]}
            />
          }
          navOpen={navOpen}
          onNavChange={({ detail }) => setNavOpen(detail.open)}
          navigation={<Navigation activeHref="/architecture" />}
          notifications={<Notifications />}
          toolsOpen={toolsOpen}
          onToolsChange={({ detail }) => setToolsOpen(detail.open)}
          tools={ToolsContent}
          content={
            <ContentLayout header={<Header variant="h1">Architecture Diagram</Header>}>
                <Container
                    header={
                    <Header
                        variant="h2"
                        //info={<InfoLink onFollow={handleInfoClick} />}
                        description="Click on Info to learn more about the services used."
                    >
                        Explore the AWS services used by Plantly!
                    </Header>
                    }
                >
                <img
                    src={arch_diagram}
                    alt={'Architecture Diagram'}
                    
                    style={{
                    maxWidth: '90%', 
                    height: 'auto',  
                    }}      
                />
                </Container>
            </ContentLayout>
          }
        />
    );
  }





